(function () {
  const section = document.querySelector('.vc-campaign-materials');
  if (!section) return;

  const navItems = Array.from(section.querySelectorAll('.vc-campaign-materials__nav-item'));
  const panels   = Array.from(section.querySelectorAll('.vc-campaign-materials__panel'));

  if (!navItems.length || !panels.length) return;

  const EASE     = 'cubic-bezier(0.7, 0.1, 0.3, 1)';
  const DUR_BASE = 0.35;

  /* Images inside hidden panels never load while lazy + display:none, so the
     first switch used to pop in. Warm them once the page is idle, and on
     intent (hover/focus) as a fallback, without touching the initial load. */
  function warmPanel(panel) {
    panel.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
  }

  function warmHiddenPanels() {
    panels.forEach((panel, i) => { if (i !== 0) warmPanel(panel); });
  }

  const whenIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  if (document.readyState === 'complete') whenIdle(warmHiddenPanels);
  else window.addEventListener('load', () => whenIdle(warmHiddenPanels), { once: true });

  let activeIndex = 0;
  let animating   = false;

  function switchTab(index) {
    if (index === activeIndex || animating) return;

    animating = true;

    const outPanel = panels[activeIndex];
    const inPanel  = panels[index];
    const outNav   = navItems[activeIndex];
    const inNav    = navItems[index];

    /* Update nav active state */
    outNav.classList.remove('is-active');
    outNav.setAttribute('aria-selected', 'false');
    inNav.classList.add('is-active');
    inNav.setAttribute('aria-selected', 'true');

    /* Bring the selected tab into view inside the nav's own horizontal scroll (mobile).
       scrollIntoView would also scroll the page vertically. */
    const navScroller = inNav.closest('.vc-campaign-materials__nav-container');
    if (navScroller && navScroller.scrollWidth > navScroller.clientWidth) {
      const scrollerLeft = navScroller.getBoundingClientRect().left;
      const itemLeft     = inNav.getBoundingClientRect().left;
      navScroller.scrollTo({
        left: navScroller.scrollLeft + (itemLeft - scrollerLeft) - (navScroller.clientWidth - inNav.offsetWidth) / 2,
        behavior: 'smooth',
      });
    }

    /* Animate out */
    gsap.to(outPanel, {
      opacity: 0,
      y: -6,
      duration: DUR_BASE,
      ease: EASE,
      onComplete() {
        outPanel.hidden = true;
        gsap.set(outPanel, { opacity: 1, y: 0 }); /* reset for next entry */

        /* Animate in */
        inPanel.hidden = false;
        gsap.fromTo(inPanel,
          { opacity: 0, y: 6 },
          {
            opacity: 1,
            y: 0,
            duration: DUR_BASE,
            ease: EASE,
            onComplete() { animating = false; },
          }
        );
      },
    });

    activeIndex = index;
  }

  /* Attach click + keyboard handlers */
  navItems.forEach((item, i) => {
    item.addEventListener('click', () => switchTab(i));
    item.addEventListener('pointerenter', () => warmPanel(panels[i]), { once: true });
    item.addEventListener('focus', () => warmPanel(panels[i]), { once: true });
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        switchTab(i);
      }
    });
  });
})();
